import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosClient from './lib/axiosClient';

export default function ChangePassword() {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm,     setConfirm]     = useState('');
  const [saving,      setSaving]      = useState(false);
  const [msg,         setMsg]         = useState(null);

  const save = async () => {
    if (!oldPassword) { setMsg({ ok:false, text:'Current password is required.' }); return; }
    if (newPassword.length < 8) { setMsg({ ok:false, text:'New password must be at least 8 characters.' }); return; }
    if (newPassword !== confirm) { setMsg({ ok:false, text:'Passwords do not match.' }); return; }
    setSaving(true); setMsg(null);
    try {
      await axiosClient.post('/api/rentals/change-password', { oldPassword, newPassword });
      setMsg({ ok:true, text:'Password changed successfully.' });
      setOldPassword(''); setNewPassword(''); setConfirm('');
    } catch(e) {
      setMsg({ ok:false, text: e.response?.data?.error || 'Failed to change password.' });
    }
    setSaving(false);
  };

  const inp = { width:'100%', background:'#252838', border:'1px solid #1e1e35', borderRadius:8, padding:'10px 14px', color:'#e2e8f0', fontSize:14, boxSizing:'border-box', marginBottom:12 };

  return (
    <div style={{ padding:32, maxWidth:480, margin:'0 auto' }}>
      <button onClick={() => navigate('/app/settings')}
        style={{ background:'none', border:'none', color:'#888', cursor:'pointer', fontSize:13, marginBottom:20, display:'flex', alignItems:'center', gap:6 }}>
        ← Back to Settings
      </button>
      <h1 style={{ color:'#fff', fontSize:24, fontWeight:800, margin:'0 0 6px' }}>🔒 Change Password</h1>
      <p style={{ color:'#888', fontSize:14, margin:'0 0 28px' }}>Update your login password</p>

      <div style={{ background:'#12121f', border:'1px solid #1e1e35', borderRadius:14, padding:24 }}>
        {msg && (
          <div style={{ padding:'10px 14px', borderRadius:8, marginBottom:16, background:msg.ok?'rgba(52,211,153,0.1)':'rgba(248,113,113,0.1)', border:`1px solid ${msg.ok?'#34d399':'#f87171'}`, color:msg.ok?'#34d399':'#f87171', fontSize:13 }}>
            {msg.text}
          </div>
        )}
        <label style={{ color:'#888', fontSize:12, fontWeight:700, textTransform:'uppercase', letterSpacing:'.5px', display:'block', marginBottom:5 }}>Current Password</label>
        <input type="password" value={oldPassword} onChange={e=>setOldPassword(e.target.value)} placeholder="••••••••" style={inp} />

        <label style={{ color:'#888', fontSize:12, fontWeight:700, textTransform:'uppercase', letterSpacing:'.5px', display:'block', marginBottom:5 }}>New Password</label>
        <input type="password" value={newPassword} onChange={e=>setNewPassword(e.target.value)} placeholder="••••••••" style={inp} />

        <label style={{ color:'#888', fontSize:12, fontWeight:700, textTransform:'uppercase', letterSpacing:'.5px', display:'block', marginBottom:5 }}>Confirm New Password</label>
        <input type="password" value={confirm} onChange={e=>setConfirm(e.target.value)} placeholder="••••••••" style={{ ...inp, marginBottom:20 }} />

        <button onClick={save} disabled={saving}
          style={{ width:'100%', padding:'12px', borderRadius:8, border:'none', background:'#f97316', color:'#fff', fontSize:14, fontWeight:700, cursor:'pointer', opacity:saving?0.6:1 }}>
          {saving ? 'Saving…' : 'Update Password'}
        </button>
      </div>
    </div>
  );
}
